
export const FormDOM = {
	clearFieldError(formElement, fieldName) {
		const field = formElement.find(`[name="${fieldName}"]`);
		if (field.length > 0) {
			field.removeClass('is-invalid');
			field.siblings('.invalid-feedback').remove();
		}
	},

	displayFieldError(formElement, fieldName, error) {
		const field = formElement.find(`[name="${fieldName}"]`);
		if (field.length > 0) {
			field.addClass('is-invalid');
			let errorElement = field.siblings('.invalid-feedback');
			if (errorElement.length === 0) {
				errorElement = $('<div class="invalid-feedback"></div>');
				field.after(errorElement);
			}
			errorElement.text(error);
		}
	},

	clearAllErrors(formElement) {
		formElement.find('.is-invalid').removeClass('is-invalid');
		formElement.find('.invalid-feedback').remove();
	},

	updateFormStateClasses(formElement, state) {
		formElement.toggleClass('form-valid', state.isValid);
		formElement.toggleClass('form-invalid', !state.isValid);
		formElement.toggleClass('form-dirty', state.isDirty);
		formElement.toggleClass('form-submitting', state.isSubmitting);
	}
};


